module.exports = __webpack_public_path__ + "static/media/Donna Neerhout.9364d6dd.png";